module.exports = __webpack_public_path__ + "media/images/themes/mandy/5-385227e159014ca51052eb0e6172d433.jpg";